export const USER_INPUT_TYPE = 'USER_INPUT'
export const SET_ATTRIBUTE_TYPE = 'SET_ATTRIBUTE'
export const TEXT_TYPE = 'TEXT'
export const SAVE_USER_INPUT_TYPE = 'SAVE_USER_INPUT'
export const CONDITIONAL_REDIRECT_TYPE = 'CONDITIONAL_REDIRECT'
export const RANDOM_REDIRECT_TYPE = 'RANDOM_REDIRECT'
export const API_CALL_TYPE = 'API_CALL'
